document.addEventListener('DOMContentLoaded', () => {
  function openSidebarCartDrawer() {
    const cartDrawerButton = document.querySelector('.elementor-menu-cart__toggle_button');
    if (cartDrawerButton) {
      cartDrawerButton.click();
      // If already open, force a refresh of visibility on mobile
      const sideCartExisting = document.querySelector('.elementor-menu-cart--cart-type-side-cart');
      if (sideCartExisting && sideCartExisting.classList.contains('elementor-menu-cart--shown')) {
        sideCartExisting.classList.remove('elementor-menu-cart--shown');
        requestAnimationFrame(() => sideCartExisting.classList.add('elementor-menu-cart--shown'));
      }
      // Also ensure mobile drawer is opened
      const mobileDrawer = document.getElementById('CartMobileDrawer');
      if (mobileDrawer && !mobileDrawer.classList.contains('active')) {
        mobileDrawer.classList.add('active');
        document.body.classList.add('cart-drawer-open');
        mobileDrawer.setAttribute('aria-hidden', 'false');
      }
      return;
    }
    const sideCart = document.querySelector('.elementor-menu-cart--cart-type-side-cart');
    if (sideCart && !sideCart.classList.contains('elementor-menu-cart--shown')) {
      sideCart.classList.add('elementor-menu-cart--shown');
    }
    const mobileDrawerFallback = document.getElementById('CartMobileDrawer');
    if (mobileDrawerFallback && !mobileDrawerFallback.classList.contains('active')) {
      mobileDrawerFallback.classList.add('active');
      document.body.classList.add('cart-drawer-open');
      mobileDrawerFallback.setAttribute('aria-hidden', 'false');
    }
  }

  function bindMobileDrawerControls() {
    const mobileDrawer = document.getElementById('CartMobileDrawer');
    if (!mobileDrawer) return;

    if (!mobileDrawer.dataset.bbBound) {
      const closeBtn = document.getElementById('closeMobileCart');
      const cartToggle = document.getElementById('cartMobile');

      if (cartToggle) {
        cartToggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          mobileDrawer.classList.toggle('active');
          const isOpen = mobileDrawer.classList.contains('active');
          document.body.classList.toggle('cart-drawer-open', isOpen);
          mobileDrawer.setAttribute('aria-hidden', String(!isOpen));
          // If opening from header button, ensure content is fresh
          if (isOpen) {
            // Refresh both drawers and header counts
            const drawerRoot = document.querySelector('#CartDrawer');
            if (drawerRoot) {
              // Use the same refresh used after add/change
              const maybeRefresh = (typeof refreshSidebarCart === 'function') ? refreshSidebarCart() : Promise.resolve();
              maybeRefresh.finally(() => {
                // Rebind again as close button was replaced
                bindMobileDrawerControls();
              });
            }
          }
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          mobileDrawer.classList.remove('active');
          mobileDrawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('cart-drawer-open');
        });
      }

      document.addEventListener('click', (event) => {
        const cartToggleEl = document.getElementById('cartMobile');
        if (
          mobileDrawer.classList.contains('active') &&
          !mobileDrawer.contains(event.target) &&
          (!cartToggleEl || !cartToggleEl.contains(event.target))
        ) {
          mobileDrawer.classList.remove('active');
          mobileDrawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('cart-drawer-open');
        }
      });

      mobileDrawer.dataset.bbBound = '1';
    }

    // Idempotent delegated close handler (survives HTML injection)
    if (!document.body.dataset.bbMobileCloseDelegated) {
      document.addEventListener('click', (e) => {
        const closeEl = e.target.closest && e.target.closest('#closeMobileCart');
        const drawerEl = document.getElementById('CartMobileDrawer');
        if (closeEl && drawerEl) {
          e.preventDefault();
          drawerEl.classList.remove('active');
          drawerEl.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('cart-drawer-open');
        }
      });
      document.body.dataset.bbMobileCloseDelegated = '1';
    }

    // Idempotent delegated toggle handler for header button
    if (!document.body.dataset.bbMobileToggleDelegated) {
      document.addEventListener('click', (e) => {
        const toggleWrapper = e.target.closest && e.target.closest('#cartMobile');
        if (toggleWrapper) {
          const drawerEl = document.getElementById('CartMobileDrawer');
          if (drawerEl) {
            e.preventDefault();
            e.stopPropagation();
            const willOpen = !drawerEl.classList.contains('active');
            drawerEl.classList.toggle('active', willOpen);
            drawerEl.setAttribute('aria-hidden', String(!willOpen));
            document.body.classList.toggle('cart-drawer-open', willOpen);
            if (willOpen) {
              // Ensure freshest content when opened from header
              refreshAllCarts({ open: false }).finally(() => bindMobileDrawerControls());
            }
          }
        }
      });
      document.body.dataset.bbMobileToggleDelegated = '1';
    }
  }

  function updateHeaderCartCount() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then((res) => res.json())
      .then((cart) => {
        const countEls = document.querySelectorAll('.elementor-button-icon-qty');
        countEls.forEach((el) => {
          el.textContent = cart.item_count;
          el.setAttribute('data-counter', cart.item_count);
        });
      })
      .catch(() => {});
  }

  function refreshAllCarts(options = { open: false }) {
    const parser = new DOMParser();
    return fetch('/?section_id=sidebar-cart', { cache: 'no-store' })
      .then((response) => response.text())
      .then((html) => {
        const doc = parser.parseFromString(html, 'text/html');
        const updatedCartDrawer = doc.querySelector('#CartDrawer');
        const currentCartDrawer = document.querySelector('#CartDrawer');
        if (updatedCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;
        }
      })
      .then(() => {
        return fetch('/?section_id=header', { cache: 'no-store' })
          .then((resp) => resp.text())
          .then((headerHtml) => {
            const hdoc = parser.parseFromString(headerHtml, 'text/html');
            const updatedMobileDrawer = hdoc.querySelector('#CartMobileDrawer');
            const currentMobileDrawer = document.querySelector('#CartMobileDrawer');
            if (updatedMobileDrawer && currentMobileDrawer) {
              currentMobileDrawer.innerHTML = updatedMobileDrawer.innerHTML;
              // Ensure rebind of controls after injection
              delete currentMobileDrawer.dataset.bbBound;
            }
          })
          .catch(() => {});
      })
      .then(() => updateHeaderCartCount())
      .then(() => {
        // Rebind interactions
        initSidebarCartInteractions();
        bindMobileDrawerControls();
        // Notify mobile snippet to re-render itself if needed
        document.dispatchEvent(new CustomEvent('bb:cart:refresh'));
        if (options.open) {
          openSidebarCartDrawer();
        }
      });
  }

  function initSidebarCartInteractions() {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;

    const bind = (container) => {
      if (!container) return;

      container.querySelectorAll('.plus').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line = Number(btn.dataset.line);
          const input = container.querySelector(`.cart-qty-input[data-line="${line}"]`);
          if (!input) return;
          const nextQty = Math.max(1, (parseInt(input.value, 10) || 0) + 1);
          updateQty(line, nextQty);
        }, { once: false });
      });

      container.querySelectorAll('.minus').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line = Number(btn.dataset.line);
          const input = container.querySelector(`.cart-qty-input[data-line="${line}"]`);
          if (!input) return;
          const nextQty = Math.max(1, (parseInt(input.value, 10) || 0) - 1);
          updateQty(line, nextQty);
        }, { once: false });
      });

      container.querySelectorAll('.cart-qty-input').forEach((input) => {
        input.addEventListener('change', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line = Number(input.dataset.line);
          const nextQty = Math.max(1, parseInt(input.value, 10) || 1);
          updateQty(line, nextQty);
        }, { once: false });
        input.addEventListener('click', (e) => e.stopPropagation(), { once: false });
        input.addEventListener('focus', (e) => e.stopPropagation(), { once: false });
      });

      container.querySelectorAll('.remove-item').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line = Number(btn.dataset.line);
          updateQty(line, 0);
        }, { once: false });
      });
    };

    function refreshSidebarCart() {
      return refreshAllCarts({ open: true });
    }

    function updateQty(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      })
        .then(() => refreshSidebarCart())
        .catch((err) => console.error('Sidebar cart qty update failed', err));
    }

    // Initial bind for currently rendered DOM
    bind(document.querySelector('#mini-cart-desktop'));
    bind(document.querySelector('#mini-cart-mobile'));
  }

  // Intercept add to cart form submissions on collection page
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
    if (form.dataset.bbCollectionBound === '1') return;
    form.dataset.bbCollectionBound = '1';
    form.addEventListener('submit', (event) => { 
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        if (submitButton.dataset.busy === '1') return;
        submitButton.dataset.busy = '1';
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((error) => Promise.reject(error));
          }
          return response.json();
        })
        .then(() => refreshAllCarts({ open: true }))
        .catch((error) => {
          console.error('Add to cart error:', error);
          const errorMessage = error && error.description ? error.description : 'There was an error adding the product to the cart.';
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
            submitButton.dataset.busy = '0';
          }
        // Already handled in refreshAllCarts when open:true
        });
    }, true);
  });
  // Ensure sidebar cart is interactive on initial load as well
  initSidebarCartInteractions();
  bindMobileDrawerControls();
});
